import React from 'react';
import cn from 'classnames';

import * as styles from './Tag.module.scss';

const SELECTABLE_ROLES = ['tab', 'option'];

const Tag = React.forwardRef(
  (
    {
      background = 'light',
      size = 'md',
      rounded = false,
      withCross = false,
      active,
      disabled,
      onClick,
      role,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    const isButton = Boolean(onClick);
    const Wrapper = isButton ? 'button' : 'div';
    const isSelectable = SELECTABLE_ROLES.includes(role);
    const isToggle = isButton && !role && active !== undefined;

    return (
      <Wrapper
        ref={ref}
        className={cn(
          styles.tag,
          styles[background],
          styles[size],
          rounded && styles.rounded,
          withCross && styles.withCross,
          active && styles.active,
          disabled && styles.disabled,
          className,
        )}
        role={role}
        aria-selected={isSelectable ? Boolean(active) : undefined}
        aria-pressed={isToggle ? Boolean(active) : undefined}
        disabled={isButton ? disabled : undefined}
        onClick={onClick}
        {...rest}
      >
        {children}
      </Wrapper>
    );
  },
);

Tag.displayName = 'Tag';

export default Tag;
